import _ from 'lodash'

/**
 * General utility functions for the waterjet / cnc stations in production
 */
export default class WaterjetUtils {


  /**
   * Calculate the cutting order of cutouts on a production panel
   * Takes into account home position for th jet & stoppage time to change settings for internal circle cutouts
   * 
   * Returns an array with the cutout indices sorted in best cutting order
   */
  static generateCuttingPathOrder(cutoutPathList, homePosition, stopHeadInternalCircleCutouts) {
    if(!cutoutPathList || cutoutPathList.length == 0)
      return []

    var startNode = {
      type: 'start',
      nodeIndex: 0,
      cutoutIndex: -1,
      entryPoint: homePosition,
      exitPoint: homePosition,
      length: 0
    }
    var cutoutNodes = [startNode]
    
    var nodeIndex = 1
    cutoutNodes = _.concat(cutoutNodes, _.compact(cutoutPathList.map((cutout, index) => {
      // Ignore disabled cutouts
      if(!cutout.enabled)
        return null

      return {
        type: 'cutout',
        nodeIndex: nodeIndex++,
        cutoutIndex: index,
        entryPoint: cutout.entryPoint,
        exitPoint: cutout.exitPoint
      }
    })))

    var openHeap = [{
      index: startNode.nodeIndex,
      visited: [startNode.nodeIndex],
      length: 0
    }]

    var edgeDistances = {}
    var validPathList = []

    // Add default cutout list order as the first valid path
    // For some shapes this is the most efficient path
    var defaultPath = []
    for(var i=0; i<cutoutNodes.length; i++)
      defaultPath.push(cutoutNodes[i].nodeIndex)
    validPathList.push({ nodeList: defaultPath })

    var safetyCount = 5000
    var bestRouteLength = -1

    while(openHeap.length > 0 && safetyCount-- > 0) {
      var curNode = openHeap.pop()
      var curCutoutNode = cutoutNodes[curNode.index]

      // If too long already, don't continue
      if(bestRouteLength >= 0 && curNode.length > bestRouteLength && curNode.visited.length < cutoutNodes.length)
        continue

      // Get all other nodes
      var foundNode = false
      cutoutNodes.forEach(otherNode => {
        // Ignore if already visited
        if(curNode.visited.includes(otherNode.nodeIndex))
          return

        if(!edgeDistances[`${curCutoutNode.nodeIndex}-${otherNode.nodeIndex}`]) {
          edgeDistances[`${curCutoutNode.nodeIndex}-${otherNode.nodeIndex}`] = curCutoutNode.exitPoint.distanceTo(otherNode.entryPoint)

          // TODO: If needs a stop, apply a distance/time penalty to the edge distances here
        }

        var newHeapLength = curNode.length + edgeDistances[`${curCutoutNode.nodeIndex}-${otherNode.nodeIndex}`]
        var newHeapVisited = _.concat(curNode.visited, [otherNode.nodeIndex])

        // If finished, check if shorter than current best finished path
        if(newHeapVisited.length == cutoutNodes.length) {
          if(bestRouteLength < 0 || newHeapLength < bestRouteLength)
            bestRouteLength = newHeapLength
        }

        foundNode = true
        openHeap.push({
          index: otherNode.nodeIndex,
          visited: newHeapVisited,
          length: newHeapLength
        })
      })

      // If no more nodes
      if(!foundNode) {
        validPathList.push({
          nodeList: curNode.visited
        })
      }
    }

    if(safetyCount <= 0)
      console.warn(`[WJ] Took too long calculating jet path`)

    var shortestPathIndex = -1
    var shortestPathDist = 0

    // Calculate path distances
    validPathList.forEach((pathInfo, index) => {
      pathInfo.totalDistance = 0

      for(var i=1; i<pathInfo.nodeList.length; i++) {
        var prevNode = pathInfo.nodeList[i-1]
        var curNode = pathInfo.nodeList[i]

        var edgeDistance = edgeDistances[`${prevNode}-${curNode}`]
        pathInfo.totalDistance += edgeDistance
      }

      // Add distance to return home
      if(pathInfo.nodeList.length > 0) {
        pathInfo.totalDistance += cutoutNodes[pathInfo.nodeList[pathInfo.nodeList.length-1]].exitPoint.distanceTo(homePosition)
      }

      if(pathInfo.totalDistance < shortestPathDist || shortestPathIndex == -1) {
        shortestPathDist = pathInfo.totalDistance
        shortestPathIndex = index
      }
    })

    if(shortestPathIndex == -1)
      return []

    // Generate cutout order
    var shortestCutoutIndexList = []
    validPathList[shortestPathIndex].nodeList.forEach(nodeIndex => {
      // Remove the home node
      if(cutoutNodes[nodeIndex].type != 'cutout')
        return
      
      shortestCutoutIndexList.push(cutoutNodes[nodeIndex].cutoutIndex)
    })

    return shortestCutoutIndexList
  }

}
